<div class="template-campaign-shell">
  <div class="template-page-header">
    <div class="template-title-bar">
      <button class="template-back-button" type="button" (click)="voltar()" aria-label="Voltar">
        <i class="fa fa-arrow-left ct-point"></i>
      </button>
      <div class="template-title-group">
        <span class="template-eyebrow">WhatsApp Oficial</span>
        <h4 class="page-title">Campanha por Template</h4>
      </div>
    </div>

    <div class="template-header-badges">
      <span class="template-status-pill">
        <i class="fas fa-shield-alt"></i>
        API Oficial
      </span>
      <span class="template-number-pill">
        <i class="fab fa-whatsapp"></i>
        {{numeroWhatsappCampanhas?.whatsapp || empresa?.whatsapp || '-'}}
      </span>
    </div>
  </div>

  <ng-container *ngIf="carregandoTela">
    <div class="template-loading">
      <div class="k-i-loading ml-1 mr-1 mt-4" style="font-size: 40px;"></div>
    </div>
  </ng-container>

  <div *ngIf="campanha.status === 'Enviando'" class="sending-panel">
    <app-gerenciador-envio-campanha [campanha]="campanha" [titulo]="'Sua campanha por template está sendo enviada'"></app-gerenciador-envio-campanha>
  </div>

  <form *ngIf="!carregandoTela" #frmCampanha="ngForm" class="template-campaign-form" novalidate>
    <div class="template-workspace">
      <main class="template-form-panel">
        <section class="template-card">
          <div class="section-heading">
            <div>
              <span class="section-kicker">Template</span>
              <h5>Dados da campanha</h5>
            </div>
            <span class="section-hint">Use um template de marketing aprovado pela Meta.</span>
          </div>

          <div class="template-fields-grid">
            <div class="form-group mb-0">
              <label for="nome">Nome da Campanha</label>
              <input type="text" class="form-control" autocomplete="off"
                     id="nome" name="nome" [(ngModel)]="campanha.nome" #nome="ngModel"
                     placeholder="Ex: Reengajamento clientes de maio" required>
              <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && nome.errors?.required">
                Nome é obrigatório
              </div>
            </div>

            <div class="form-group mb-0">
              <label for="template">Template aprovado</label>
              <kendo-combobox id="template" name="template" class="template-combo"
                              [data]="templatesFiltrados"
                              [textField]="'nomeTemplate'"
                              [valueField]="'id'"
                              [filterable]="true"
                              [placeholder]="'Pesquisar template aprovado...'"
                              [(ngModel)]="templateSelecionado"
                              (filterChange)="filtreTemplates($event)"
                              (ngModelChange)="mudouTemplate()">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                  <div class="template-option">
                    <div class="template-option-header">
                      <strong>{{dataItem.nomeTemplate}}</strong>
                      <span class="badge badge-primary" *ngIf="dataItem.templateFacebook">Facebook</span>
                      <span class="badge badge-secondary" *ngIf="dataItem.templateSistema">Sistema</span>
                      <span class="badge badge-success">Aprovado</span>
                      <span class="badge badge-info">Marketing</span>
                    </div>
                    <div class="template-option-message">{{dataItem.textoMensagem}}</div>
                    <div class="template-option-cta" *ngIf="dataItem.botoes?.length">
                      CTA: {{dataItem.botoes[0].text || dataItem.botoes[0].value || 'Botão do template'}}
                    </div>
                  </div>
                </ng-template>
                <ng-template kendoComboBoxValueTemplate let-dataItem>
                  <span *ngIf="dataItem">{{dataItem.nomeTemplate}}</span>
                </ng-template>
              </kendo-combobox>
              <div class="template-field-note">
                <i class="fas fa-check-circle"></i>
                Somente templates de marketing aprovados.
              </div>
            </div>
          </div>

          <div class="form-group mt-3 mb-0" *ngIf="templateSelecionadoExigeImagem()">
            <app-upload-imagem [objeto]="campanha" [label]="'Imagem do cabeçalho'" [prop]="'linkImagem'"
                               [maxsize]="800" (onEnviou)="trocouImagem($event)"></app-upload-imagem>
            <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && erroImagemObrigatoria()">
              Envie uma imagem para o cabeçalho do template.
            </div>
          </div>
        </section>

        <section class="template-card">
          <div class="section-heading">
            <div>
              <span class="section-kicker">Audiência</span>
              <h5>Contatos</h5>
            </div>
            <span class="section-hint">Escolha a origem e aplique os filtros de envio.</span>
          </div>

          <div class="form-group mb-3">
            <label>Origem dos contatos</label>
            <div class="contact-source-options">
              <label class="source-pill" for="origemContatos1">
                <input type="radio" #origemContatos="ngModel" name="origemContatos" id="origemContatos1"
                       class="k-radio right" kendoRadioButton value="Filtro"
                       [(ngModel)]="campanha.origemContatos" required (ngModelChange)="mudouOrigemContatos()"/>
                <span><i class="fas fa-filter"></i> De um Filtro</span>
              </label>
              <label class="source-pill" for="origemContatos2">
                <input type="radio" #origemContatos="ngModel" name="origemContatos" id="origemContatos2"
                       class="k-radio right ml-2" kendoRadioButton value="Arquivo"
                       [(ngModel)]="campanha.origemContatos" required (ngModelChange)="mudouOrigemContatos()"/>
                <span><i class="far fa-file-alt"></i> Arquivo</span>
              </label>
              <label class="source-pill" for="origemContatos3">
                <input type="radio" #origemContatos="ngModel" name="origemContatos" id="origemContatos3"
                       class="k-radio right ml-2" kendoRadioButton value="Todos"
                       [(ngModel)]="campanha.origemContatos" required (ngModelChange)="mudouOrigemContatos()"/>
                <span><i class="fas fa-users"></i> Todos</span>
              </label>
            </div>
          </div>

          <div class="contact-filter-row" *ngIf="campanha.origemContatos === 'Filtro'">
            <div class="form-group mb-3">
              <label for="filtro">Filtro de contatos</label>
              <kendo-combobox id="filtro" name="filtro" [(ngModel)]="campanha.filtro" [data]="filtros"
                              class="template-combo" [placeholder]="'Selecione um filtro'"
                              #filtro="ngModel"
                              [textField]="'nome'" [valueField]="'id'"
                              [kendoDropDownFilter]="filterSettings" required
                              (ngModelChange)="filtreContatos()">
              </kendo-combobox>
              <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && filtro.errors?.required">
                Filtro é obrigatório
              </div>
            </div>
          </div>

          <div [hidden]="campanha.origemContatos !== 'Arquivo'" class="upload-row">
            <app-upload-contatos-campanha #uploadContatos [campanha]="campanha" (onNovosContatos)="usuarioFezUploadContatos($event)" required></app-upload-contatos-campanha>
            <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && campanha.origemContatos === 'Arquivo' && erroContatosObrigatorios()">
              Envie um arquivo com contatos
            </div>
            <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && arquivoSelecionadoSemContatosValidos()">
              O arquivo foi selecionado, mas nenhum contato válido foi encontrado.
            </div>
          </div>

          <div class="campaign-options-grid">
            <div class="form-group mb-0 campaign-hygiene-option">
              <label>Higiene da campanha</label>
              <label class="k-checkbox-label">
                <input type="checkbox" id="naoEnviarRecente" name="naoEnviarRecente" class="k-checkbox" kendoCheckBox
                       [(ngModel)]="campanha.naoEnviarMsgParaQuemRecebeuRecente" (ngModelChange)="mudouQtdeMensagensAEnviar()" />
                Não enviar para quem recebeu campanha recente
              </label>
            </div>

            <div class="form-group mb-0">
              <label>Limitar contatos?</label>
              <div class="compact-radio-row">
                <label class="k-radio-label" for="limitarQtdeMensagensSim">
                  <input type="radio" name="configQtdeMsgs" id="limitarQtdeMensagensSim"
                         class="k-radio right ml-2" [value]="true" [(ngModel)]="campanha.limitarQtdeContatos"
                         (click)="mudouQtdeMensagensAEnviar()" kendoRadioButton />
                  Sim
                </label>
                <label class="k-radio-label" for="limitarQtdeMensagensNao">
                  <input type="radio" name="configQtdeMsgs" id="limitarQtdeMensagensNao"
                         class="k-radio right ml-2" [value]="false" kendoRadioButton
                         [(ngModel)]="campanha.limitarQtdeContatos" (click)="mudouQtdeMensagensAEnviar()" />
                  Não
                </label>
              </div>
            </div>

            <div class="form-group mb-0" *ngIf="campanha.limitarQtdeContatos">
              <label for="qtdeMensagens">Quantidade</label>
              <input type="number" class="form-control" autocomplete="off"
                     id="qtdeMensagens" name="qtdeMensagens" [(ngModel)]="campanha.qtdeContatosEnviarMsg"
                     #qtdeMensagens="ngModel"
                     (ngModelChange)="mudouQtdeMensagensAEnviar()" required min="1">
              <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && qtdeMensagens.invalid">
                Informe uma quantidade válida
              </div>
            </div>

            <div class="form-group mb-0" *ngIf="campanha.naoEnviarMsgParaQuemRecebeuRecente">
              <label for="qtdeDiasUltimaNotificacao">Campanha recente</label>
              <div class="days-input-wrap">
                <input type="number" class="form-control" autocomplete="off"
                       id="qtdeDiasUltimaNotificacao" name="qtdeDiasUltimaNotificacao"
                       [(ngModel)]="campanha.qtdeDiasUltimaNotificacao"
                       #qtdeDiasUltimaNotificacao="ngModel"
                       (ngModelChange)="mudouQtdeMensagensAEnviar()" required min="1">
                <span>dias</span>
              </div>
              <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && qtdeDiasUltimaNotificacao.invalid">
                Informe a quantidade de dias
              </div>
            </div>
          </div>

          <div class="contact-summary" *ngIf="!carregandoContatos && resumo !== null">
            <span>Total de contatos selecionados</span>
            <strong>{{resumo.total}}</strong>
          </div>
          <div class="invalid-feedback d-block" *ngIf="deveMostrarValidacao() && campanha.origemContatos === 'Todos' && erroContatosObrigatorios()">
            Não há contatos disponíveis para envio
          </div>

          <div class="k-i-loading ml-1 mr-1 p-4" style="font-size: 40px;" *ngIf="carregandoContatos"></div>

          <div class="alert alert-danger mt-3" *ngIf="mensagemErro">
            <i class="fas fa-exclamation-triangle"></i> <span [innerHTML]="mensagemErro"></span>
          </div>

          <div class="alert alert-success mt-3" *ngIf="mensagemSucesso">
            <i class="fas fa-check-circle"></i> {{mensagemSucesso}}
          </div>
        </section>

        <div class="actions-row">
          <button type="button" class="btn btn-light btn-lg" [disabled]="salvando || enviando" (click)="apenasSalvar()">
            <i class="far fa-save"></i>
            Salvar rascunho
            <i *ngIf="salvando" class="k-i-loading k-icon ml-1"></i>
          </button>
          <button type="button" class="btn btn-primary btn-lg" [disabled]="salvando || enviando" (click)="enviarCampanha()">
            <i class="far fa-paper-plane"></i>
            Enviar campanha
            <i *ngIf="enviando" class="k-i-loading k-icon ml-1"></i>
          </button>
        </div>
      </main>

      <aside class="template-rail">
        <div class="rail-card preview-rail-card">
          <div class="rail-card-header">
            <div>
              <span>Mensagem</span>
              <h5>Prévia</h5>
            </div>
            <i class="fab fa-whatsapp"></i>
          </div>

          <div class="phone-preview-shell">
            <div class="template-preview" [class.template-preview-empty]="!templateSelecionado">
              <ng-container *ngIf="templateSelecionado; else emptyTemplatePreview">
                <div class="template-preview-title">{{templateSelecionado.nomeTemplate}}</div>
                <div class="template-preview-subtitle" *ngIf="templateSelecionado.headerText">{{templateSelecionado.headerText}}</div>
                <div class="template-preview-media" *ngIf="templateSelecionadoExigeImagem()">
                  <i class="far fa-image"></i>
                </div>
                <div class="template-preview-body">{{templateSelecionado.textoMensagem}}</div>
                <div class="template-preview-time">11:30 <i class="fas fa-check-double"></i></div>
                <div class="template-preview-buttons" *ngIf="templateSelecionado.botoes?.length">
                  <span *ngFor="let botao of templateSelecionado.botoes" class="template-preview-button">
                    {{botao.text || botao.value || 'CTA'}}
                    <i class="fas fa-external-link-alt"></i>
                  </span>
                </div>
              </ng-container>

              <ng-template #emptyTemplatePreview>
                <div class="template-preview-title">Nome do template</div>
                <div class="template-preview-subtitle">Header (opcional)</div>
                <div class="template-preview-media">
                  <i class="far fa-image"></i>
                </div>
                <div class="template-preview-body">
                  Olá {{'{{1}}'}}, tudo bem?<br>
                  Esta é uma mensagem de exemplo usando o template selecionado.
                </div>
                <div class="template-preview-time">11:30 <i class="fas fa-check-double"></i></div>
                <div class="template-preview-buttons">
                  <span class="template-preview-button">
                    Botão 1
                    <i class="fas fa-external-link-alt"></i>
                  </span>
                  <span class="template-preview-button">
                    Botão 2
                  </span>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="rail-card summary-panel">
          <div class="summary-header">
            <span>Resumo</span>
            <strong>{{resumo?.total || contatos?.length || 0}}</strong>
          </div>
          <div class="summary-grid">
            <div class="summary-row">
              <span>Template</span>
              <strong>{{templateSelecionado?.nomeTemplate || '-'}}</strong>
            </div>
            <div class="summary-row">
              <span>Origem</span>
              <strong>{{templateSelecionado?.origemTemplate || '-'}}</strong>
            </div>
            <div class="summary-row" *ngIf="templateSelecionadoExigeImagem()">
              <span>Imagem</span>
              <strong>{{campanha.linkImagem ? 'Enviada' : '-'}}</strong>
            </div>
            <div class="summary-row">
              <span>Número Cloud</span>
              <strong>{{numeroWhatsappCampanhas?.whatsapp || empresa?.whatsapp || '-'}}</strong>
            </div>
          </div>
        </div>
      </aside>
    </div>
  </form>
</div>
